import { render, staticRenderFns } from "./LKRoadmapsFeedButtonAdd.vue?vue&type=template&id=6cecd468&"
import script from "./LKRoadmapsFeedButtonAdd.vue?vue&type=script&lang=js&"
export * from "./LKRoadmapsFeedButtonAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports